<div class="separator-line"></div>

<article class="newsletter-section">
  <div class="newsletter-wrapper">
    
    <header class="newsletter-header">
      <h2 class="titre-newsletter">Restez à l'affût</h2>
      <p class="content">
			Inscrivez-vous pour être informé des offres exclusives et des animations dans nos cafés-jeux.<br/>
			Ne manquez rien de l'univers de La Caverne Du Gobelin !
      </p>
    </header>

    <div class="form-container">
      <div class="input-group">
        <div class="form-floating">
          <input type="email" 
                 class="newsletter-input" 
                 id="email-newsletter" 
                 placeholder="Mon e-mail" 
                 [(ngModel)]="news.email"/>
        </div>
        <button (click)="subscribe()" class="btn-subscribe">
          M'inscrire
        </button>
      </div>
    </div>

  </div>
</article>



